export * from './src/ngxerror.directive';
export * from './src/ngxerrors.directive';
export * from './src/ngxerrors.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ultimate/ngxerrors/index.js
// module id = 115
// module chunks = 323